import { getConfig } from '@cian/config/browser';
import { getHttpApi } from '@cian/http-api/browser';
import { getLogger } from '@cian/logger/browser';
import { getTelemetry } from '@cian/telemetry/browser';
import { registry } from '@cian/mf-registry/browser';

import type { IApplicationContext, IApplicationContextCustom } from 'shared/types/applicationContext';

export const createContext = (): IApplicationContext => {
  const config = getConfig();

  return {
    config,
    custom: config.getStrict<IApplicationContextCustom>('applicationContext.custom'),
    httpApi: getHttpApi(),
    logger: getLogger(),
    telemetry: getTelemetry(),
    microfrontendsRegistry: registry(),
  };
};
